<template>
    <v-chip :color="tag.color" label :light="darkMode" class="mr-2 mb-2" v-on="canClick ? { click: () => toggleTag() } : null">
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                    <span v-on="on">
                        {{ tag.name }}
                          <v-avatar right v-show="tag.state === 1">
                            <v-icon>{{ icon }}</v-icon>
                         </v-avatar>
                    </span>
            </template>
            {{ tooltip }}
        </v-tooltip>
    </v-chip>
</template>

<script>

import {mapState} from "vuex";
import {isEmpty} from "lodash";

export default {
    name: 'message-tag',
    props: [
        'tag',
        'message',
    ],
    computed: {
        ...mapState({
              messageCategories: state => state.messages.categories,
        }),
        tooltip() {
            return this.tag.state === 1 ? this.tag.tooltipActive: this.tag.tooltipInactive;
        },
        canClick() {
            if (!this.$can('manage', 'Message'))
                return false;

            const regex = /FWD_(\d+)/gm;
            const forwardTag = regex.exec(this.tag.code);

            if (!isEmpty(forwardTag)) {

              const targetMessageCategoryId =  Number(forwardTag[1]);
              const event = this.$store.getters["events/getByKey"](this.message.eventUuid);
              const messageCategory = Object.values(this.messageCategories).find(category => category.categoryId === targetMessageCategoryId);
              const conversation = Object.values(event.conversations).find(conv => conv.type === messageCategory.id);

              if (!conversation || !this.$can('manage', 'Message')) {
                return false;
              }
            }

            if (this.tag.state === 0)
                return true;

            return this.tag.state === 1 && this.tag?.options?.canRemove === 1;
        },
        icon() {
            return this.tag.state ? 'done' : 'done'
        },
        darkMode() {
            return this.tag.colorText === 'dark';
        },
        colorText() {
            return this.tag.colorText === 'light' ? 'white' : 'black';
        },
    },
    methods: {
        toggleTag() {
            this.$emit('onTagClick', this.tag, this.tag.state === 1 ? 0 : 1);
            return false;
        },
    },
}
</script>
